import _ from 'lodash'
import store from '../store'

const auth = {
  namespaced: true,
  state: {
    user: null,
    observers: {
      user: null,
    },
    vapidKey: null
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
      if (payload) {
        localStorage.setItem(this.$config.userKey, JSON.stringify(payload))
        try {
          this.$api.defaults.headers.common['Authorization'] =  `bearer ${payload.token}`
        } catch( error ) {
          console.error(error);
        }
      } else {
        localStorage.removeItem(this.$config.userKey)
      }
    },
    setAuthorized (state, payload) { state.authorized = payload },
    setVapidKey(state, payload){
      state.vapidKey = payload
    }
  },
  actions: {
    // AUTH Changed
    authChanged ({state, commit, dispatch, rootState}) {
      let once = true
      return this.$auth().onAuthStateChanged(async user => {
        if (user) {
          store.$router.replace('/splash')
          await dispatch('getIdToken').then(async idToken => {
            if (state.observers.user) { 
              state.observers.user() 
            }

            state.observers.user = await this.$db().collection('users')
            .doc(user.uid)
            .onSnapshot(async doc => {
              const data = doc.data()
              let payload = {
                ...user.providerData[0],
                token: idToken.token,
                claims: idToken.claims,
                ...data,
                uid: doc.id
              }

              // Get Configs
              await dispatch('getConfigs', {user: payload},  {root: true}) 

              // Update User
              const updatedUser = await dispatch('updateUser', {user: payload}) 

              if (!state.authorized) {
                commit('setAuthorized', true)
              }
              if (!rootState.offline && !updatedUser.superAdmin && !updatedUser.isAdminCompanySelected && rootState.companySelected?.claims?.syncOffline) {
                // Sincroniza os dados para uso offline
                dispatch('registers/syncOffline',{$router: store.$router}, {root: true})
                setInterval(() => {
                  dispatch('registers/syncOffline',{$router: store.$router}, {root: true})
                }, rootState.companySelected?.claims?.syncOfflineInterval || 1000*60*60); // 60min
              }

              if(once){
                // Get Token to Push Notify
                dispatch('registerNotificationToken')
                once = false
              }

              if(['/login', '/splash'].includes(store.$router.currentRoute.value.path)) { 
                store.$router.replace('/') 
              }
            })
          })
              
        } else {
          commit('setUser', null)
          commit('registers/resetRegisters', {}, { root: true })
          commit('registers/resetCounters', {}, { root: true })
          commit('setAuthorized', false)
          dispatch('closeListeners')

          if(store.$router.currentRoute.value.path != '/login') { 
            store.$router.push('/login') 
          }
        }
      })
    },
    async updateUser ({state, commit, dispatch, rootState}, {user}) {
      if (!user) user = state.user
   
      // SA3
      user.SA3 = await dispatch('getSA3', {uid:user.uid})
      // if(user.SA3) user.SA3Subs = await dispatch('getSA3Subs', {A3_COD:user.SA3.A3_COD})
      const tenantId = await dispatch('registers/getCustomer', 'SA3', {root: true})
      const userRules = rootState.registers && rootState.registers.registers ? rootState.registers.registers.userRules : null
      const rulesCompany = user && user.companies && user.companies[tenantId] ? user.companies[tenantId].rules : null

      if (rulesCompany && rulesCompany.length > 0 && userRules && userRules.length > 0) {
        user.seeAllSalers = rulesCompany.some(rule => userRules.some(ur => ur.id === rule && ur.seeAllSalers))
      }

      // Cria um atalho para retornar se user é admin da filial logada.
      if (
        user.companies 
        && rootState.companySelected 
        && rootState.companySelected.groupCompany
        && user.companies[rootState.companySelected.groupCompany] 
        && user.companies[rootState.companySelected.groupCompany].admin
      ) {
        user.isAdminCompanySelected = true
      }

      commit('setUser', user)
      
      return user
    },
    async getSA3 ({dispatch}, {uid}) {
      const collection = 'SA3'
      
      const SA3 = await dispatch('registers/get', { collection, filters: [{key: 'A3_USRPORT', operator: '==', value: uid}], limit: 1, forceFilter: true}, {root: true})
      return (SA3 && SA3.length > 0) ? SA3[0] : null
    },
    async getSA3Subs ({state, dispatch}, {SA3, superAdmin}) {
      const collection = 'SA3'
      let SA3regs = []
      const tenantId = await dispatch('registers/getCustomer', 'SA3', {root: true})
      if (superAdmin || state.user?.companies[tenantId]?.admin || state.user?.seeAllSalers) {
        const SA3All = await dispatch('registers/get', { collection, limit: 9999, filters: [{key: 'active', operator: '==', value: true}]}, {root: true})
        SA3regs = SA3All || []
      } else if (SA3) {
        // busque os registros de vendedores em que o usuário logado seja o gerente
        const SA3Geren = await dispatch('registers/get', { collection, limit: 9999, filters: [{key: 'A3_GEREN', operator: '==', value: SA3.A3_COD}]}, {root: true})
  
        // busque os registros de vendedores em que o usuário logado seja o superior
        const SA3Super = await dispatch('registers/get', { collection, limit: 9999, filters: [{key: 'A3_SUPER', operator: '==', value: SA3.A3_COD}]}, {root: true})
        SA3regs = [SA3, ...SA3Geren, ...SA3Super]
      }
      return SA3regs
    },
    async recoverPassword({dispatch}, {user_email}){
      var actionCodeSettings = {
        // After password reset, the user will be give the ability to go back
        // to this page.
        url: 'https://ufmanage.ufsales.com.br',
        handleCodeInApp: false
      };

      return this.$auth().sendPasswordResetEmail(user_email?.trim(), actionCodeSettings)
        .then(res => {
          return res.user
        })
        .catch(err => {
          let message = ''
          switch (err.code) {
            case 'auth/invalid-email':
              message = 'E-mail inválido!'
              break;
            case 'auth/user-disabled':
              message = 'Usuário desabilitado!'
              break;
            case 'auth/user-not-found':
              message = 'Usuário não encontrado!'
              break;
            case 'auth/invalid-action-code':
              message = 'Link de acesso inválido. Link expirado ou já foi usado!'
              break;
            default:
              message = err.message
              break;
          }
        })
    },

    async registerNotificationToken({state, dispatch}){
      if (!this.$messaging) return
      let cloudMessaging = await this.$db().collection('_configs').doc("cloudMessaging").get()

      let {vapidKey} = cloudMessaging.data()

      this.$messaging.getToken({ vapidKey })
      .then((currentToken)=>{
        let now = new Date()
        let tokensParaComparar = []
        
        // listo todos os tokens que o usuário tem registrado e que estão dentro da validade
        let registeredTokens = []
        if (state.user && state.user.notificationTokens) {
          registeredTokens = state.user.notificationTokens.map((notificationToken)=>{
            
            // calculamos o tempo de validade do token
            let tokenValido = Math.round((Date.parse(now) - Date.parse(notificationToken.updatedAt))/86400000) <= 60 ? true :false
  
            // se o token estiver dentro da validade, ele permanece na lista de tokens de notificação do usuario
            if(tokenValido){
              // com essa lista nós podemos testar se currenttoken já está cadastrado ou não
              tokensParaComparar.push(notificationToken.token)
  
              // atualizamos a validade do token
              notificationToken.updatedAt = now
  
              return notificationToken
            }
          });
        }
    
        if(!tokensParaComparar.includes(currentToken) || (registeredTokens.length === 0)){
          registeredTokens.push({
            token: currentToken,
            createdAt: now,
            updatedAt: now
          })

          // dispatch('registers/save', {collection: 'users', item: {id: state.user.uid, email: state.user.email, notificationTokens: registeredTokens}, notToast: true, updateNotificationToken: true}, {root: true})
        }
      })
    },

    // CLOSE LISTENERS
    closeListeners ({state, rootState}) {
      // Auth
      if (state.observers.user) { state.observers.user() }
     
      // Registers
      const registersObservers = rootState.registers.observers
      for (const key in registersObservers) {
        if (Object.prototype.hasOwnProperty.call(registersObservers, key)) {
          const registersSnapshots = registersObservers[key].snapshots
          registersSnapshots.forEach(el => {
            el()
          });
        }
      }
    },

    // SIGN
    signIn ({commit, dispatch}, {email, password}) {
      if (!email || !password) return {error: 'E-mail ou senha não informados!'}
      return this.$auth().signInWithEmailAndPassword(email.trim(), password.trim())
        .then(res => {
          commit('setUser', res.user)
          return res.user
        })
        .catch(async err => {
          const message = await dispatch('translateError', err)
          return {error: message}
        });
    },
    translateError({}, err) {
      let message = ''
      switch (err.code) {
        case 'auth/invalid-email':
          message = 'E-mail inválido!'
          break;
        case 'auth/wrong-password':
          message = 'A senha é inválida ou o usuário não possui uma senha.!'
          break;
        case 'auth/too-many-requests':
          message = 'o acesso a esta conta foi temporariamente desativado devido a muitas tentativas de login malsucedidas. você pode restaurá-lo imediatamente redefinindo sua senha ou pode tentar novamente mais tarde!'
          break;
        case 'auth/user-disabled':
          message = 'Usuário desabilitado!'
          break;
        case 'auth/user-not-found':
          message = 'Usuário não encontrado!'
          break;
        case 'auth/invalid-action-code':
          message = 'Link de acesso inválido. Link expirado ou já foi usado!'
          break;
        case 'auth/argument-error':
          message = 'E-mail ou senha não informados!'
          break;
        default:
          message = err.message
          break;
      }
      return message
    },
    signOut () {
      this.$auth().signOut()
    },
    getIdToken () {
      return this.$auth().currentUser.getIdTokenResult(/* forceRefresh */ true)
        .then(idTokenResult => idTokenResult)
        .catch(err => err);
    },
    refreshToken ({dispatch, commit, state}) {
      return dispatch('getIdToken').then(idToken => {
        const payload = {
          ...state.user,
          token: idToken.token,
          claims: idToken.claims
        }
        // payload.uid = state.user.uid
        commit('setUser', payload)
        return payload
      })
    },
  },
  getters: {
    getUser: (state) => {
      return state.user;
    }
  }
}

export default auth